import React from "react";
import {
    Col,
    Container,
} from "reactstrap";



const Models3dPlus = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col lg={12}>
                        <p>en cours</p>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Models3dPlus;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license